import { KST as defaultOptions } from "./defaultOptionsForComputation";
import { getSourcePathAccessor } from "../utils";
import { sma } from "./index";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const {
      sourcePath,
      roc1,
      roc2,
      roc3,
      roc4,
      sma1,
      sma2,
      sma3,
      sma4,
      signal,
    } = options;
    const source = getSourcePathAccessor(sourcePath);

    // Step 1: Calculate 4 ROC (Rate of Change) values
    const roc1Data = [];
    const roc2Data = [];
    const roc3Data = [];
    const roc4Data = [];

    for (let i = 0; i < data.length; i++) {
      const currentValue = source(data[i]);

      // ROC1
      if (i >= roc1 && data[i - roc1]) {
        const pastValue = source(data[i - roc1]);
        if (pastValue !== 0 && pastValue != null) {
          roc1Data.push(100 * (currentValue / pastValue - 1));
        } else {
          roc1Data.push(undefined);
        }
      } else {
        roc1Data.push(undefined);
      }

      // ROC2
      if (i >= roc2 && data[i - roc2]) {
        const pastValue = source(data[i - roc2]);
        if (pastValue !== 0 && pastValue != null) {
          roc2Data.push(100 * (currentValue / pastValue - 1));
        } else {
          roc2Data.push(undefined);
        }
      } else {
        roc2Data.push(undefined);
      }

      // ROC3
      if (i >= roc3 && data[i - roc3]) {
        const pastValue = source(data[i - roc3]);
        if (pastValue !== 0 && pastValue != null) {
          roc3Data.push(100 * (currentValue / pastValue - 1));
        } else {
          roc3Data.push(undefined);
        }
      } else {
        roc3Data.push(undefined);
      }

      // ROC4
      if (i >= roc4 && data[i - roc4]) {
        const pastValue = source(data[i - roc4]);
        if (pastValue !== 0 && pastValue != null) {
          roc4Data.push(100 * (currentValue / pastValue - 1));
        } else {
          roc4Data.push(undefined);
        }
      } else {
        roc4Data.push(undefined);
      }
    }

    // Step 2: Apply SMA to each ROC (sourcePath: undefined for raw arrays)
    const sma1Calculator = sma().options({
      windowSize: sma1,
      sourcePath: undefined,
    });
    const sma2Calculator = sma().options({
      windowSize: sma2,
      sourcePath: undefined,
    });
    const sma3Calculator = sma().options({
      windowSize: sma3,
      sourcePath: undefined,
    });
    const sma4Calculator = sma().options({
      windowSize: sma4,
      sourcePath: undefined,
    });

    const sma1Data = sma1Calculator(roc1Data);
    const sma2Data = sma2Calculator(roc2Data);
    const sma3Data = sma3Calculator(roc3Data);
    const sma4Data = sma4Calculator(roc4Data);

    // Step 3: Calculate weighted KST = 1*SMA1 + 2*SMA2 + 3*SMA3 + 4*SMA4
    const kstData = [];
    for (let i = 0; i < data.length; i++) {
      if (
        sma1Data[i] != null &&
        sma2Data[i] != null &&
        sma3Data[i] != null &&
        sma4Data[i] != null
      ) {
        kstData.push(
          1 * sma1Data[i] + 2 * sma2Data[i] + 3 * sma3Data[i] + 4 * sma4Data[i],
        );
      } else {
        kstData.push(undefined);
      }
    }

    // Step 4: Calculate signal line (SMA of KST, sourcePath: undefined for raw array)
    const signalCalculator = sma().options({
      windowSize: signal,
      sourcePath: undefined,
    });
    const signalData = signalCalculator(kstData);

    // Combine into final result
    const results = [];
    for (let i = 0; i < data.length; i++) {
      if (kstData[i] != null) {
        results.push({
          kst: kstData[i],
          signal: signalData[i],
        });
      } else {
        results.push(undefined);
      }
    }

    return results;
  }

  calculator.undefinedLength = function () {
    // Maximum period needed to start calculating
    const { roc4, sma4, signal } = options;
    return roc4 + sma4 + signal - 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) return options;
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
